import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AgentProjectSummaryGetCollection, AgentProjectSummaryGetCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AgentProjectSummaryGetCollectionResponse, AgentProjectSummaryGetCollectionResponse>) => {
    return response?.data?.agentProjectSummaries
}
const getError = (response?: SWRResponse<AgentProjectSummaryGetCollectionResponse, AgentProjectSummaryGetCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useAgentProjectSummaries = (configuration?: SWRConfiguration<AgentProjectSummaryGetCollectionResponse, AgentProjectSummaryGetCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AgentProjectSummaryGetCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useAgentProjectSummaries;